import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {KitchenDisplaySearchModel} from "../kitchen-display-search.model";
import {KitchenDisplayEntityModel} from "../kitchen-display-entity.model";

@Component({
    selector: "wbo-kitchen-display-search-page",
    templateUrl: "./kitchen-display-search-page.component.html",
    providers: [
        provideSearchModel(KitchenDisplaySearchModel),
        provideEntityModel(KitchenDisplayEntityModel)
    ]
})
export class KitchenDisplaySearchPageComponent extends AbstractSearchPage {
}
